import { render, staticRenderFns } from "./MtsTakipBilgileriForm.vue?vue&type=template&id=2be9af60&scoped=true"
import script from "./MtsTakipBilgileriForm.vue?vue&type=script&lang=ts"
export * from "./MtsTakipBilgileriForm.vue?vue&type=script&lang=ts"
import style0 from "./MtsTakipBilgileriForm.vue?vue&type=style&index=0&id=2be9af60&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2be9af60",
  null
  
)

export default component.exports